export type InsightNavItem = {
  path: string;
  label: string;
};

export type InsightNavCategory = {
  label: string;
  items: InsightNavItem[];
};

export const INSIGHTS_NAV = {
  label: 'Articles',
  categories: [
    {
      label: 'Research',
      items: [
        { path: '/the-great-reimagining', label: 'The Great Reimagining' },
        { path: '/from-smart-to-self-aware', label: 'From Smart to Self-Aware' },
      ],
    },
    {
      label: 'News',
      items: [
        { path: '/the-death-of-the-office-cube', label: 'Office-to-Residential Revolution' },
        { path: '/the-great-leap-from-smart-to-autonomous', label: 'The Great Leap: From Smart to Autonomous' },
      ],
    },
  ],
} as const;

export const INSIGHTS_LINKS: InsightNavItem[] = INSIGHTS_NAV.categories.flatMap(
  (category) => category.items as readonly InsightNavItem[]
);

export function isInsightsPath(pathname: string): boolean {
  return INSIGHTS_LINKS.some((item) => item.path === pathname);
}
